module.exports = __webpack_public_path__ + "img/4_of_Hearts.svg.1f81d8e9.png";